import axiosInstance from '@/api/axiosInstance';
import type { CourseDetail } from '@/types/learningCenter';

/**
 * Fetch complete course details including modules and user enrollment
 * GET /api/learning-center/courses/:id
 */
export const getCourseDetail = async (id: number): Promise<CourseDetail> => {
  const response = await axiosInstance.get<any>(
    `/api/learning-center/courses/${id}`
  );

  const data = response.data;

  // Debug logging
  console.log('getCourseDetail - Raw backend response:', data);
  console.log('getCourseDetail - Backend enrollment:', data.enrollment);

  // Transform backend response to frontend format
  const transformed = {
    ...data,
    id: parseInt(data.id, 10),
    estimated_hours: data.estimated_hours?.toString() || '0',
    enrollment: data.enrollment ? {
      id: parseInt(data.enrollment.id, 10),
      status: data.enrollment.status,
      progress_percentage: data.enrollment.progress_percentage || 0,
      started_at: data.enrollment.started_at,
      completed_at: data.enrollment.completed_at,
      last_accessed_at: data.enrollment.last_accessed_at,
      last_accessed_module_id: data.enrollment.last_accessed_module_id ?? null,
    } : null,
    modules: (data.modules || []).map((module: any) => ({
      id: module.id,
      title: module.title,
      description: module.description,
      type: module.type,
      duration: module.duration,
      order_number: module.order_number,
      status: module.module_progress?.status?.toLowerCase() || 'not-started',
      completed_at: module.module_progress?.completed_at || null,
      contentBlocks: module.contentBlocks || [],
    })),
  } as CourseDetail;

  console.log('getCourseDetail - Transformed enrollment:', transformed.enrollment);

  return transformed;
};
